export type BindingType = {
  pages: {
    min: number;
    max: number;
  };
  caseAllowance: number;
  spine: boolean;
  multiplesValue: number;
};

// The value is hardcoded and will be used when the thickness is not provided
const DEFAULT_THICKNESS_150 = 0.128 as const;
// This value is hardcoded (from legacy formula)
const SPINE_WIDTH_INCREASE_VALUE = 0.2 as const;

// The formula thickness * (pages / 2) + caseAllowance then finally
// we take this value then add 0.2 and ceil the value
export const calculateSpineWidth = (pages: number, caseAllowance: number, thickness?: number) =>
  Math.ceil(
    (thickness ?? DEFAULT_THICKNESS_150) * (pages / 2) + caseAllowance + SPINE_WIDTH_INCREASE_VALUE,
  );

// We should validate pages value based on Binding Settings
export const validatePages = (pages: number, settings: BindingType) =>
  isNaN(pages) ||
  pages < settings.pages.min ||
  pages > settings.pages.max ||
  pages % settings.multiplesValue !== 0;
